import { addDays } from 'date-fns/addDays';
import { currentDateFormatted } from '../../utils';

const CURRENT_ERROR_MSG = 'PAST_DATE_ERROR_1';
const FUTURE_ERROR_MSG = 'REQUESTED_BY_DATE_FUTURE_DATE';

/**
 * @param {string} cutOffType
 * @param {Object} requestByDate
 * @param {Boolean} requestByDate.cutOffEnabled
 * @param {Object} requestByDate.cutOffTimes
 * @returns {Object}
 */
const useGetMinDateInfo = ({ cutOffType, requestByDate = {} }) => {
  const { cutOffTimes = {}, cutOffEnabled } = requestByDate;
  const fulfillmentSpecificCutOff = cutOffTimes[cutOffType];

  /**
   * fulfillmentSpecificCutOff might have three different values.
   * Those values are string ('1/1/2023T00:00') , empty string ('') or boolean depend on which service comes from.
   * if it's an empty string, then it means that todays cutOff time has passed
   * if the string contains a date time, then today's cutOff time has not yet passed
   */
  const isCutOffPassed =
    typeof fulfillmentSpecificCutOff === 'boolean'
      ? fulfillmentSpecificCutOff
      : !fulfillmentSpecificCutOff;

  const now = currentDateFormatted();
  if (cutOffEnabled && isCutOffPassed) {
    return {
      minDate: addDays(now, 1),
      minDateErrorMessage: FUTURE_ERROR_MSG,
      isCutOffPassed
    };
  }
  return {
    minDate: now,
    minDateErrorMessage: CURRENT_ERROR_MSG,
    isCutOffPassed
  };
};

export default useGetMinDateInfo;
